import React, { Fragment, useState } from "react";
import { Select, MenuItem, withStyles, createStyles } from "@material-ui/core";

export const StyledSelect = withStyles((theme) =>
  createStyles({
    root: {
      fontSize: theme.typography.body2.fontSize,
    },
    select: {
      "&:focus": {
        backgroundColor: theme.palette.common.white,
      },
    },
  })
)(Select);

export const MeterDropdown = ({
  meters,
  selected,
  callback,
  additionalOption,
}) => {
  const [selectedData, setSelectedData] = useState(selected);

  return Array.isArray(meters) && meters.length >= 1 ? (
    <StyledSelect
      fullWidth
      value={selectedData}
      onClick={(e) => {
        if (typeof e.target.value === "number") {
          setSelectedData(e.target.value);
          callback(e.target.value);
        }
      }}
    >
      {additionalOption && <MenuItem value={-1}>{additionalOption}</MenuItem>}
      {meters.map((meter, index) => (
        <MenuItem key={index} value={index}>
          {meter.name || meter.description}
        </MenuItem>
      ))}
    </StyledSelect>
  ) : null;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/MeterDropdown/MeterDropdown.js